import { clsx } from "clsx";
import type { FeedFilter } from "@/features/feed/types";

const OPTIONS: { value: FeedFilter; label: string }[] = [
	{ value: "all", label: "Tudo" },
	{ value: "public", label: "Públicos" },
	{ value: "internal", label: "Internos" },
];

interface FeedFiltersProps {
	value: FeedFilter;
	onChange: (value: FeedFilter) => void;
}

export function FeedFilters({ value, onChange }: FeedFiltersProps) {
	return (
		<div className="feed-filters">
			{OPTIONS.map((option) => (
				<button
					key={option.value}
					type="button"
					onClick={() => onChange(option.value)}
					className={clsx(
						"feed-filters__option",
						value === option.value && "is-active",
					)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
}
